import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { selectSearchType } from "application/features/search/searchSlice";
import { useTranslation } from "react-i18next";
import { StockNumericType, StockEnum } from "data/enums";

export interface Heading2Props {
  className?: string;
  city?: string;
  region?: string;
  check_in: string;
  check_out: string;
  guests: number;
  results: number;
}

const Heading2: React.FC<Heading2Props> = ({
  className = "",
  city,
  region,
  check_in,
  check_out,
  guests,
  results,
}) => {
  const { t, ready } = useTranslation("translation");
  const searchType = useSelector(selectSearchType);
  
  const isStaySearch: boolean = searchType === StockNumericType.STAY || searchType === StockEnum.STAY;
  const isExperienceSearch: boolean = searchType === StockNumericType.EXPERIENCE || searchType === StockEnum.EXPERIENCE;
  const isHolidayPackageSearch: boolean = searchType === StockNumericType.HOLIDAY_PACKAGE || searchType === StockEnum.HOLIDAY_PACKAGE;

  if (!ready) return null;

  const searchTypeLabelCity = isStaySearch ? 
    t("translation:search.pages.destinations.searchTypeLabelCity") : 
    isExperienceSearch ? 
      t("translation:search.pages.experiences.searchTypeLabelCity") : 
      isHolidayPackageSearch ? 
        t("translation:search.pages.holidayPackages.searchTypeLabelCity") : 
        t("translation:search.common.uncategorizedResultHeader");

  const searchTypeLabelRegion = isStaySearch ? 
    t("translation:search.pages.destinations.searchTypeLabelRegion") : 
    isExperienceSearch ? 
      t("translation:search.pages.experiences.searchTypeLabelRegion") : 
      isHolidayPackageSearch ? 
        t("translation:search.pages.holidayPackages.searchTypeLabelRegion") : 
        t("translation:search.common.uncategorizedResultHeader");

  const searchTypeLabelNoLocation = isStaySearch ? 
    t("translation:search.pages.destinations.searchTypeLabelNoLocation") : 
    isExperienceSearch ? 
      t("translation:search.pages.experiences.searchTypeLabelNoLocation") : 
      isHolidayPackageSearch ? 
        t("translation:search.pages.holidayPackages.searchTypeLabelNoLocation") : 
        t("translation:search.common.uncategorizedResultHeader");

  const unspecifiedDateLabel = t("translation:search.common.unspecifiedDates");

  const resultsLabel = results === 1 ? t("translation:search.common.resultStringSingular") : t("translation:search.common.resultStringPlural");

  const guestNumberLabel = guests === 1 ? t("translation:search.common.guestStringSingular") : t("translation:search.common.guestStringPlural");

  return (
    <div className={`mb-12 lg:mb-16 ${className}`}>
      {city && (
          <h2 className="text-4xl font-semibold">{`${searchTypeLabelCity} ${city}`}
          </h2>
        )
      }
      {(region && !city )
        && (
          <h2 className="text-4xl font-semibold">{`${searchTypeLabelRegion} ${region}`}</h2>
        )
      }
      {
        (!city && !region) && (
          <h2 className="text-4xl font-semibold">
            {searchTypeLabelNoLocation}
          </h2>
        )
      }
      <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
        {`${results} ${resultsLabel}`}
        <span className="mx-2">·</span>
        {
          check_in && check_out ?
          moment(check_in).format("DD MMM") + " - " + moment(check_out).format("DD MMM")
          : unspecifiedDateLabel
        }
        <span className="mx-2">·</span>{`${guests} ${guestNumberLabel}`}
      </span>
    </div>
  );
};

export default Heading2;
